import React, {useState, useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { useForm } from "react-hook-form";
import { SubmitForm} from "@gull";
import axios from 'axios'
import swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Tabs, Tab } from "react-bootstrap";

const useLoad = () => {
    const t = useTranslate();
    const [loading,setLoading] = useState(true)
    const [sections,setSections]=useState([])
    const [customFields,setCustomFields]=useState(false)

    // Charge les customFields To
    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/to/all"
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }else{
                    setCustomFields(response.data.custom_fields)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoading(false)
        })()
    }, [])
    // Charge les sections
    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/section"
            ).then((response) => {
                setSections(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
        })()
    }, [])

    return [loading,setLoading,sections,setSections,customFields,setCustomFields];
}

const ModalCreateTo = (props) => {
    const t = useTranslate();
    
    const { register, formState: { errors }, handleSubmit, setValue, reset, getValues} = useForm();
    const [loading,setLoading,sections,setSections,customFields,setCustomFields] = useLoad()
    const [validButton,setValidButton] = useState(false)
    const [apiError,setApiError] = useState(false)
    const [success,setSuccess] = useState(false)
    const [toTemp, setToTemp] = useState({});
    const [tabsKey, setTabsKey] = useState('to');

    const idsLocalStorage=localStorage.getItem("pos").split(',')
    const to_storage_name = 'to_temp_'+idsLocalStorage[0]

    // Date du jour
    let now = new Date();
    let annee   = now.getFullYear();
    let mois    = now.getMonth() + 1;
    let jour    = now.getDate();
    let moisFormat = (mois>9) ? mois : '0'+mois;
    let jourFormat = (jour>9) ? jour : '0'+jour;
    // end

    // Charge la date du jour par défaut
    useEffect(function () {
        setValue('expected',annee+'-'+moisFormat+'-'+jourFormat)
    }, [])

    // Chargement du localstorage
    useEffect(() => {
        setToTemp((localStorage.getItem(to_storage_name)!=null) ? JSON.parse(localStorage.getItem(to_storage_name)) : {});
    }, []);

    // Mise à jour du localstorage
    useEffect(() => {
        localStorage.setItem(to_storage_name, JSON.stringify(toTemp))
    }, [toTemp]);

    // On ne peux valider que s'il y a au moins un article renseigné
    useEffect(() => {
        if (Object.keys(toTemp).length==0) setValidButton(true)
        else setValidButton(false)
    }, [toTemp]);

    const onSubmit = async (data) => {
        setValidButton(true)
        setApiError(false)
        setSuccess(false)

        let obj = {}
        obj = {
            ...data,
            article:Object.entries(toTemp).map(([index,value]) => {
                return index
            }),
            tomove:Object.entries(toTemp).map(([index,value]) => {
                return value.quantity
            })
        }

        const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/to",obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                    }
                    else{
                        messageError+=t(interm)+'<br/>'
                    }
                })
                    messageError=messageError.replace('undefined','');
                    setApiError(messageError)
            }
            else{
                setSuccess(true)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setValidButton(false)
        setTimeout(()=>{
            handleCancel()
        },1000)
        
    }

    // Modification de quantité
    const handleChangeQuantity = (key,value) => {
        setToTemp(prev => (
            {
                ...prev,
                [key]:{...prev[key], quantity:value}
            }
        ))
    }

    // Appelé quand on quitte le champ
    const handleBlurQuantity = (key, value) => {
        if (value=='') {
            setToTemp(prev => (
                {
                    ...prev,
                    [key]: { ...prev[key], quantity:0}
                }
            ));
        }
    };

    // Supprimer une ligne
    const handleDeleteLine = (key) => {
        setToTemp(prev => {
            const copy = {...prev}
            delete copy[key]
            return copy;
        });
    }

    // Annulation de la création To
    const handleCancel = () => {
        reset();
        setToTemp({});
        localStorage.removeItem(to_storage_name);
        setApiError(false);
        setSuccess(false);
        props.setShowTo(false);
        props.setTo(false)
    };

    return(
        <>
            <div className='mt-3'>
                <Tabs activeKey={tabsKey} id="uncontrolled-tab-example" onSelect={(k)=>setTabsKey(k)}>
                    <Tab eventKey="to" title={t('to')}>
                        {(loading || sections.length==0) ?
                            <span className="d-flex justify-content-center"><span className="spinner-border spinner-border-sm"></span></span>
                        :
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-group">
                                    <label htmlFor="date de transfert">{t('transfert_le')+' :'}</label>
                                    <input  type='date' className="form-control" {...register('expected', {required: true})}/>
                                    {errors.expected?.type === 'required' && (
                                    <div className="text-danger mt-1 ml-2">
                                        {t('expectedRequired')}
                                    </div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="commerce de destination">{t('destination_section')+' :'}</label>
                                    <select disabled={true} className="form-control" type="text">
                                        <option key={props.section.id} value={props.section.id}>{props.section.name}</option>                                  
                                    </select>
                                    <input
                                        type="hidden"
                                        {...register('fsection', { required: true })}
                                        value={props.section.id}
                                    />
                                    {errors.fsection?.type === 'required' && (
                                    <div className="text-danger mt-1 ml-2">
                                        {t('fsectionRequired')}
                                    </div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="commerce d'origine">{t('origin_section')+' :'}</label>
                                    <select disabled={validButton} className="form-control" type="text" {...register('osection', {required: true})}>
                                        <option value="">-- Select --</option>
                                        {(sections.length!=0) && sections.map((value)=>{
                                            if(value.type!='ecommerce') return(<option key={value.id} value={value.id}>{value.name}</option>)
                                        })}                                    
                                    </select>
                                    {errors.osection?.type === 'required' && (
                                    <div className="text-danger mt-1 ml-2">
                                        {t('osectionRequired')}
                                    </div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="memo">Memo :</label>
                                    <textarea rows={5} className="form-control" {...register('memo')}/>
                                </div>        
                                {/* Affichage customFields To */}
                                {(customFields.length!=0) && customFields.map((item)=>(
                                    <div className="form-group" key={item.id}>
                                        <label htmlFor={item.name}>{item.name}{(item.required) ? '*' : false}</label>
                                        {(item.free) ?
                                            <>
                                                <input className="form-control" type="text" {...register(item.name,{required:item.required})}/>
                                                {errors[item.name]?.type === 'required' && (
                                                <div className="text-danger mt-1 ml-2">
                                                    {t('youMustIndicateField')+' "'+item.name+'"'}
                                                </div>
                                                )}
                                            </>
                                            :
                                            <>
                                                <select className="form-control" {...register(item.name,{required:item.required})} >
                                                    <option value="">-- Select --</option>
                                                    {item.list.map((value,index)=>
                                                        <option key={index} value={value}>{value}</option>
                                                    )}
                                                </select>
                                                {errors[item.name]?.type === 'required' && (
                                                <div className="text-danger mt-1 ml-2">
                                                    {t('youMustIndicateField')+' "'+item.name+'"'}
                                                </div>
                                                )}
                                            </>
                                        }
                                    </div>
                                ))}
                                <div>
                                    {(apiError) ? <div className="alert alert-danger mt-3" dangerouslySetInnerHTML={{ __html: props.error }}></div> : false}
                                    {(success) ? <div className="alert alert-success mt-3">{t('successOperation')}</div> : false}
                                    <button disabled={validButton} className="btn btn-primary mt-3">{t('btnValidate')}</button>
                                    <button
                                        type="button"
                                        className="btn btn-danger mt-3 ms-2"
                                        onClick={() =>
                                            swal.fire({
                                                title: t('delete_current_to_pos'),
                                                icon: "warning",
                                                type: "question",
                                                showCancelButton: true,
                                                confirmButtonColor: "#3085d6",
                                                cancelButtonColor: "#d33",
                                                confirmButtonText: t('btnYes'),
                                                cancelButtonText: t('btnNo'),
                                            })
                                            .then((result) => {
                                                if (result.value) {
                                                    handleCancel()
                                                }
                                            })
                                        }
                                        disabled={(validButton && Object.keys(toTemp).length!=0)}
                                    >
                                        {t('btnCancel')}
                                    </button>
                                </div>
                            </form>
                        }
                    </Tab>
                    <Tab eventKey="article" title={t('items')}>
                        <div>
                            <div className='row'>
                                <h5>{t('listOfItems')}</h5>
                            </div>
                            <div className='table-responsive'>
                                <table id="to_table" className="table">
                                    <thead>
                                        <tr>
                                            <th>{t('name')}</th>
                                            <th className='text-center'>{t('sku_vendeur')}</th>
                                            <th className='text-center'>{t('quantity')}</th>
                                            <th className='text-center'>{t('delete')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(toTemp).length!=0 && Object.entries(toTemp).map(([index,value])=>
                                            <tr key={index}>
                                                <td>{value.name}</td>
                                                <td className='text-center'>{value.sku}</td>
                                                <td className='text-center'><input min={0} required value={value.quantity} className="form-control" type="number" onChange={(e) => handleChangeQuantity(index, e.target.value)} onBlur={(e) => handleBlurQuantity(index, e.target.value)}/></td>
                                                <td className='text-center'><FontAwesomeIcon icon={faTrash} className='text-danger pointer' onClick={()=>handleDeleteLine(index)}/></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </div>
        </>
    )
}

export default ModalCreateTo;
